/**
 * Colunas default dos workflows novos (Projetos 2.0 F2.1) — espelham a
 * Migration 168. O `<KanbanBoard>` usa os overrides do admin quando existem;
 * estes são o fallback canônico.
 *
 * Arquivo separado da página (não-componente) por causa do react-refresh.
 */
import { type DefaultStage } from '@/lib/use-kanban-columns';

// FU-4 (fluxo unificado): colunas do quadro Compras. Migration 281 (5 situações) +
// FX-35: "Aprovado" (= liberada, a efetivar) é coluna por DERIVAÇÃO (`situacao_mapeada=NULL`,
// o card entra/sai pelo `realizado_aprovacao_status`, nunca por drag) — read-only no Quadro.
// Fase 2 de Compras (decisão do Matheus, 15/09/2026): a ALÇADA DO FINANCEIRO MORREU — as colunas
// "Aguardando aprovação" e "Recusado" saíram (mig 617 as desativa no banco).
// Fase 2 (16/09/2026): "A classificar" também é derivada — o card entra/sai pelo STATUS da
// solicitação (classificar é o gesto), nunca por arrastar. A aba "Fila do Compras" morreu com ela.
export const COMPRAS_APROVACAO_SLUGS = ['a_classificar', 'aprovado'] as const;
export const COMPRAS_STAGES: DefaultStage[] = [
  { slug: 'a_classificar', label: 'A classificar', ordem: 1, variant: 'warning' },
  { slug: 'a_cotar', label: 'A cotar', ordem: 2, variant: 'warning' },
  { slug: 'em_cotacao', label: 'Em cotação', ordem: 3, variant: 'info' },
  { slug: 'aprovado', label: 'Aprovado', ordem: 5, variant: 'info' },
  { slug: 'comprado', label: 'Comprado', ordem: 6, variant: 'success' },
  { slug: 'recebido', label: 'Recebido', ordem: 7, variant: 'info' },
  { slug: 'entregue', label: 'Entregue', ordem: 8, variant: 'success' },
];

export const FINANCEIRO_STAGES: DefaultStage[] = [
  { slug: 'solicitado', label: 'Solicitado', ordem: 1, variant: 'warning' },
  { slug: 'analise', label: 'Em análise', ordem: 2, variant: 'info' },
  { slug: 'aprovado', label: 'Aprovado', ordem: 3, variant: 'info' },
  { slug: 'pago', label: 'Pago', ordem: 4, variant: 'success' },
];
